<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-10 15:05:32
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-12 10:32:23
-->
<template>
	<!-- 添加合作团长 -->
	<div>
		<el-drawer class="add-cooperation-partner" title="添加合作团长" size="724px" :append-to-body="true" :visible.sync="visible" @closed="reset">
			<!-- 搜索框部分 -->
			<div class="pos-rela">
				<el-input placeholder="请输入团长名称" v-model="institution_name" clearable></el-input>
				<el-button class="searchBtn" @click="getTzList()">搜索</el-button>
			</div>
			<!-- 新增团长提示按钮部分 -->
			<div class="flex-just-end flex-row mt-12">
				<el-button @click="showPartnerDrawer" type="text">没找到?新增团长</el-button>
			</div>
			<!-- 列表部分 -->
			<el-checkbox-group v-model="selectedTz">
				<div class="mt-12 pos-rela colonel-table" v-loading="loading">
					<div class="colonel-table-header">
						<div class="colonel-table-tr">
							<div class="colonel-table-td" style="width: 65px"></div>
							<div class="colonel-table-td" style="width: 605px">团长名称</div>
						</div>
					</div>
					<div
						class="colonel-table-body"
						v-scroll-lazy-load="{
							loadData,
							distance: 300,
							delay: 1000,
							callback: fn => this.$once('hook:beforeDestroy', () => fn()),
						}"
					>
						<div class="colonel-table-tr" v-for="item in tzList" :key="item.team_institution_id">
							<div class="colonel-table-td text-align-center" style="width: 65px">
								<el-checkbox :label="item.team_institution_id"></el-checkbox>
							</div>
							<div class="colonel-table-td" style="width: 605px">{{ item.institution_name }}</div>
						</div>
						<p class="pt-20 pb-20 font-h4-regular yx-color-text-regular flex-center">
							<i class="el-icon-loading fz-16 mr-4" v-if="loadmore.status === 'loading'"></i>
							<span :class="loadmore.status === 'nomore' ? 'nomore' : ''">{{ loadmore.text }}</span>
						</p>
					</div>
				</div>
			</el-checkbox-group>
			<!-- 底部按钮部分 -->
			<div class="bott">
				<span class="pl-24 font-h5-regular yx-color-text-primary">
					已选
					<span class="yx-color-primary">{{ selectedNum }}</span>
					个，最多可选
					<span class="yx-color-primary">{{ limit }}</span>
					个
				</span>
				<div>
					<el-button @click="handleClose">取 消</el-button>
					<el-button type="primary" @click="submit" :loading="btnloading" :disabled="isAble">保存</el-button>
				</div>
			</div>
		</el-drawer>
		<partner-dialog ref="partnerDialog" />
		<Kpartner-dialog ref="KpartnerDialog" />
	</div>
</template>

<script>
import { getInstitutionBaseList } from '@/api/secondColonelManage';
import partnerDialog from '@/views/secondColonelManage/cooperativeColonel/components/partnerDialog';
import KpartnerDialog from '@/views/secondColonelManage/cooperativeColonel/components/KpartnerDialog';
export default {
	name: 'ChooseCooColonelDrawer',
	components: {
		partnerDialog,
		KpartnerDialog,
	},
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_ALL.value,
		},
	},
	data() {
		return {
			visible: false,
			selectedTz: [], // 选中的团长id
			tzList: [], //团长列表
			institution_name: '', //搜索框输入的团长名称
			loading: true,
			btnloading: false,
			limit: 20,
			disabledList: [],
			selectObjArr: [], // 选中的团长对象
			params: {
				page_index: 1,
				page_size: 20,
			},
			loadmore: {
				text: '加载更多',
				status: 'pending',
			},
		};
	},
	watch: {
		institution_name(val) {
			if (!val) {
				this.getTzList();
			}
		},
		selectedTz(val, pre) {
			// 新增
			if (val.length > pre.length) {
				// 找出新增的ID
				const addedIdArr = val.filter(item => !pre.includes(item));
				// 匹配当前的列表找出新增的对象
				const addedObjArr = this.tzList.filter(item => addedIdArr.includes(item.team_institution_id));
				// 添加到选中的对象列表中
				this.selectObjArr.push(...addedObjArr);
			} else {
				// 找出新增的ID
				const deledIdArr = pre.filter(item => !val.includes(item));
				// 匹配当前的列表找出新增的对象
				deledIdArr.forEach(element => {
					// 匹配找出删除的对象
					const ind = this.selectObjArr.findIndex(item => element === item.team_institution_id);
					// 在选中的对象列表中删除
					this.selectObjArr.splice(ind, 1);
				});
			}
		},
	},
	computed: {
		// 已选的个数，外部选中的团长个数+抽屉中已选中的团长个数
		selectedNum() {
			return this.selectedTz.length + this.disabledList.length;
		},
		isAble() {
			return this.selectedNum > this.limit;
		},
	},
	methods: {
		show(list = []) {
			if (list.length) {
				this.disabledList = list;
			}
			this.getTzList();
			this.visible = true;
		},
		loadData() {
			// 有下一页才会请求接口
			if (this.loadmore.status === 'nomore') {
				return;
			}
			this.params.page_index++;
			this.loadmore = {
				text: '加载中...',
				status: 'loading',
			};
			this.getTzList(true);
		},
		//获取团长列表
		async getTzList(loadMore) {
			if (!loadMore) {
				this.params.page_index = 1;
				this.loading = true;
			}
			if (loadMore && this.loadmore.status === 'nomore') {
				return;
			}
			let { code, data } = await getInstitutionBaseList({ ...this.params, institution_name: this.institution_name, platform_id: this.platformId });

			if (code == 0) {
				if (loadMore) {
					if (data.page.page_has || data.list.length) {
						this.tzList = this.tzList.concat(data.list);
					}
				} else {
					this.tzList = data.list;
				}
				this.loadmore = !data.page.page_has
					? {
							text: '已经到底了',
							status: 'nomore',
					  }
					: {
							text: '加载更多',
							status: 'pending',
					  };
				if (!loadMore) {
					this.loading = false;
				}
			}
		},
		// 保存提交
		submit() {
			this.btnloading = true;
			let params = {};
			const { selectObjArr } = this;
			params = selectObjArr.map(item => {
				// 每次选择团长时添加唯一ID，原因为可重复添加团长
				item.id = item.team_institution_id + '|' + new Date().getTime();
				return item;
			});
			//给该对象加一个id值，且和团长id一样
			this.$emit('getTzList', params);
			this.$message.success('添加成功');
			this.btnloading = false;
			this.reset();
			this.handleClose();
		},
		// 关闭
		handleClose() {
			this.visible = false;
			this.params.page_index = 1;
		},
		// 重置
		reset() {
			this.selectedTz = [];
			this.tzInfo = '';
			this.tzList = [];
			this.params.page_index = 1;
			this.disabledList = [];
			this.institution_name = '';
			this.selectObjArr = [];
		},
		// 打开新增团长的抽屉
		showPartnerDrawer() {
			let obj = {
				[dataMap.PLATFORM_DY.value]: this.$refs.partnerDialog.show,
				[dataMap.PLATFORM_KS.value]: this.$refs.KpartnerDialog.show,
			};
			obj[this.platformId]();
			this.visible = false;
		},
	},
};
</script>

<style lang="less" scoped>
.add-cooperation-partner {
	/deep/.el-input {
		width: 606px !important;
	}
	/deep/ .el-drawer__body {
		padding: 24px !important;
		&::-webkit-scrollbar {
			width: 6px;
		}

		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @border-color-lighter;
		}
	}
	/deep/ .el-checkbox__label {
		display: none;
	}
}
.searchBtn {
	width: 72px;
	background-color: @color-primary;
	color: #ffffff;
	font-size: 13px;
	border-radius: 2px;
	position: absolute;
	right: 0;
	top: -1px;
}
.tzName {
	border-top: 1px solid #ebedf5;
	border-bottom: 1px solid #ebedf5;
	background-color: #f7f8fa;
	padding-left: 77px;
}
.tzTable {
	height: 50px;
	line-height: 50px;
}
.btline {
	border-bottom: 1px solid #ebedf5;
}
.line {
	position: absolute;
	width: 1px;
	background-color: @border-color-base;
	height: 100%;
	top: 0;
	left: 65px;
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2;
}
/deep/ .el-checkbox__inner {
	border: 1px solid #e2e3e8;
}
.colonel-table {
	display: table;
	width: 100%;
	margin-bottom: 40px;
	&-header {
		color: @color-text-secondary !important;
		font-size: 12px !important;
		font-family: PingFangSC-Regular;
	}
	&-body {
		max-height: 650px;
		overflow-y: auto;
		.nomore {
			&::before {
				content: '- ';
			}
			&::after {
				content: ' -';
			}
		}
	}
	&-tr {
		display: table-row;
	}
	&-td {
		display: table-cell;
		font-size: 12px;
		padding: 12px 0;
		border-bottom: 1px solid @border-color-base;
	}
}
&::-webkit-scrollbar {
	width: 6px;
}

&::-webkit-scrollbar-thumb {
	height: 26px;
	border-radius: 3px;
	background-color: @color-text-placeholder;
}
</style>
